<template>
  <v-container>
    <v-row>
      <v-col cols="4">
        <v-card class="card pa-2" color="primary" dense height="64">
          <v-container>
            <v-row align="center">
              <v-col cols="6">
                <div class="text-subtitle-2 font-weight-bold">Asistieron</div>
              </v-col>
              <v-col cols="6" align="right">
                <div class="d-inline text-subtitle-1 font-weight-black">{{ totalAsistidos }}</div>
                <div class="d-inline text-subtitle-1 mx-2">de</div>
                <div class="d-inline text-subtitle-1 font-weight-black">{{ personal.length }}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card class="card pa-2" color="primary" dense height="64">
          <v-container>
            <v-row align="center">
              <v-col cols="8">
                <div class="text-subtitle-2 font-weight-bold">Promedio general</div>
              </v-col>
              <v-col cols="4" align="right">
                <div class="text-subtitle-1 font-weight-black">{{ promedioGeneral }}</div>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" lg="4">
        <v-text-field
          v-model="buscaPersonal"
          color="secondary"
          background-color="primary"
          rounded
          filled
          placeholder="Buscar personal por nombre, edad, municipio o estado..."
          append-icon="mdi-magnify"
        ></v-text-field>
      </v-col>
      <v-col cols="12 mb-3" align="right">
        <v-btn
          class="secondary card mt-2 px-8"
          rounded
          elevation="8"
          v-on:click="save()"
          :disabled="loading"
          :loading="loading"
        >
          Guardar evaluación <v-icon small class="ml-2">mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="buscaPersonal.length > 0">
        <div class="text-h6 font-weight-bold">
          {{ filteredPersonal.length }} resultados encontrados con la búsqueda "{{ buscaPersonal }}"
        </div>
      </v-col>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemsCurso"
          class="transparent"
          hide-default-footer
          disable-pagination
          dense
        >
          <template v-slot:item.CUIP="{ item }">
            <div>{{ item.CUIP }}</div>
          </template>
          <template v-slot:item.nombre="{ item }">
            <div>{{ item.nombre }}</div>
          </template>
          <template v-slot:item.segundoNombre="{ item }">
            <div>{{ item.segundoNombre }}</div>
          </template>
          <template v-slot:item.apaterno="{ item }">
            <div>{{ item.apaterno }}</div>
          </template>
          <template v-slot:item.amaterno="{ item }">
            <div>{{ item.amaterno }}</div>
          </template>
          <template v-slot:item.asistencia="{ item }">
            <v-icon :color="item.asistencia ? 'success' : 'error'">
              {{ item.asistencia ? 'mdi-check-circle' : 'mdi-close-circle' }}
            </v-icon>
          </template>
          <template v-slot:item.calificacion="{ item }">
            <div>{{ item.calificacion }}</div>
          </template>
          <template v-slot:item.calificacionEvaluacion="{ item }">
            <div>{{ item.calificacionEvaluacion }}</div>
          </template>
          <template v-slot:item.comentario="{ item }">
            <div style="white-space: pre-line">{{ item.comentario }}</div>
          </template>
          <template v-slot:item.acciones="{ item }">
            <span class="d-inline-flex">
              <v-btn icon color="secondary" small @click="openEditModalCalificar(item)">
                <v-icon>mdi-message-draw</v-icon>
              </v-btn>
              <v-btn icon color="secondary" small @click="openEditModalDelete(item)">
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </span>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { textInputProps } from '../../components/props/props'
import { DIALOG_TYPES } from '../../plugins/dialog-types'

export default {
  props: {
    // ID del curso programado
    id: {
      type: Number,
    },
  },

  data() {
    return {
      textInputProps,
      buscaPersonal: '',
      ordenAlfabetico: 0,
      loading: false,
      headers: [
        { text: 'CUIP', value: 'cuip', align: 'center' },
        { text: 'Nombre', value: 'nombre', align: 'center' },
        { text: 'Segundo Nombre', value: 'segundoNombre', align: 'center' },
        { text: 'Apellido Paterno', value: 'apaterno', align: 'center' },
        { text: 'Apellido Materno', value: 'amaterno', align: 'center' },
        { text: 'Asistencia', value: 'asistencia', sortable: false, align: 'center' },
        { text: 'Calificación', value: 'calificacion', align: 'center' },
        { text: 'Calificación Evaluador', value: 'calificacionEvaluacion', align: 'center' },
        { text: 'Comentario', value: 'comentario', align: 'center' },
        { text: 'Opciones', value: 'acciones', sortable: false, align: 'center' },
      ],
      DIALOG_TYPES,
    }
  },

  computed: {
    ...mapGetters('cursoAsignado', {
      personalCurso: 'getCursosAsignados',
    }),
    ...mapGetters('cursoProgramado', { cursosProgramados: 'getCursosProgramados' }),

    personal: function () {
      return this.personalCurso.filter((cursoPersonal) => {
        return cursoPersonal.fk_idProgramacionCurso == this.id
      })
    },

    filteredPersonal: function () {
      return this.personal.filter((cursoPersonal) => {
        return cursoPersonal
      })
    },

    totalAsistidos: function () {
      var total = 0
      this.personal.forEach((cursoPersonal) => {
        if (cursoPersonal.asistencia == true) {
          total++
        }
      })
      return total
    },

    promedioGeneral: function () {
      let suma = 0
      let total = 0

      this.personal.forEach((cursoPersonal) => {
        if (
          cursoPersonal.asistencia === true &&
          cursoPersonal.calificacion &&
          !isNaN(parseFloat(cursoPersonal.calificacion))
        ) {
          suma += parseFloat(cursoPersonal.calificacion)
          total++
        }
      })

      if (total === 0) return 0
      return (suma / total).toFixed(1)
    },

    groupedPersonal: function () {
      var result = _(this.filteredPersonal)
        .groupBy((cursoPersonal) => cursoPersonal.Personal.apaterno[0].toUpperCase())
        .map((cursoPersonal, inicial) => ({ inicial, cursoPersonal }))
        .value()

      if (this.ordenAlfabetico == 0) {
        result.sort(function (a, b) {
          if (a.inicial < b.inicial) {
            return -1
          }
          if (a.inicial > b.inicial) {
            return 1
          }
          return 0
        })
      } else {
        result.sort(function (a, b) {
          if (a.inicial > b.inicial) {
            return -1
          }
          if (a.inicial < b.inicial) {
            return 1
          }
          return 0
        })
      }
      return result
    },
    itemsCurso() {
      return this.filteredPersonal.map((cursoPersonal) => ({
        cuip: cursoPersonal.Personal.CUIP,
        nombre: cursoPersonal.Personal.nombre,
        segundoNombre: cursoPersonal.Personal.segundoNombre,
        apaterno: cursoPersonal.Personal.apaterno,
        amaterno: cursoPersonal.Personal.amaterno,
        asistencia: cursoPersonal.asistencia,
        calificacion: cursoPersonal.calificacion,
        calificacionEvaluacion: cursoPersonal.calificacionEvaluacion,
        comentario: cursoPersonal.comentario,
        // agrega más campos si los necesitas
      }))
    },
  },

  mounted() {
    const selectedCurso = this.cursosProgramados.find((curso) => curso.id === this.id)
    if (selectedCurso) {
      this.SET_SELECTED_CURSO_PROGRAMADO(selectedCurso)
    }
  },

  methods: {
    ...mapActions('cursoAsignado', ['updateCursoAsignado']),
    ...mapMutations('dialog', ['SET_DIALOG']),
    ...mapMutations('cursoProgramado', ['SET_SELECTED_CURSO_PROGRAMADO']),

    save: async function () {
      this.loading = true

      this.personal.forEach((cursoPersonal) => {
        if (cursoPersonal.file) {
          cursoPersonal.evidencia = cursoPersonal.file.name
        }
      })
      console.log(this.personal)
      await this.updateCursoAsignado(this.personal)

      this.$router.push('/profesionalizacion/cursos_programados')
      this.loading = false
    },
    openEditModalCalificar(item) {
      const persona = this.personal.find((p) => p.Personal.CUIP === item.cuip)
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.CALIFICAR_CURSO,
        props: { personal: persona },
      })
    },
    openEditModalDelete(item) {
      const asignacion = this.personal.find((p) => p.Personal.CUIP === item.cuip)
      this.SET_DIALOG({
        ...this.DIALOG_TYPES.DESVINCULAR_CURSO,
        props: {
          asignacion: {
            idPersonal: asignacion.Personal.idPersonal,
            idAsignacionCurso: asignacion.id,
            nombre: asignacion.Personal.nombre,
            segundoNombre: asignacion.Personal.segundoNombre,
            apaterno: asignacion.Personal.apaterno,
            amaterno: asignacion.Personal.amaterno,
          },
        },
      })
    },
  },
}
</script>
